import type { SVGProps } from 'react';
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.091 18.98a.89.89 0 0 1-.64-.26L7.39 12.89c-.25-.24-.39-.568-.39-.905s.12-.664.36-.905l6.06-5.832A.93.93 0 0 1 14.057 5c.237 0 .464.09.634.25a.86.86 0 0 1 .273.603.86.86 0 0 1-.242.617l-.02.019-5.69 5.505 5.72 5.505c.35.337.36.875.02 1.222l-.02.02c-.17.163-.4.259-.64.259"
    />
  </svg>
);
export default SvgChevronLeft;
